module.exports = __webpack_public_path__ + "img/juuqo-logo-white.78989538.png";